const scrollWithOffset = (element: HTMLElement): void => {
  const header = document.querySelector('.ODSStandardGlobalHeader');
  const headerOffset = header ? (header as HTMLElement).offsetHeight / 1.5 : 0;

  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};

export { scrollWithOffset };
